import { IHttpApi } from '@cian/http-api/shared';
import {
  fetchSearchRegionsCities,
  ISearchRegionsCitiesRequest,
  ISearchRegionsCitiesResponse,
  ISearchRegionsCitiesResponse200,
  ISearchRegionsCitiesResponse400,
  ISearchRegionsCitiesResponseError,
} from '../repositories/monolith-python/v1/search-regions-cities';

import { isResponseContainsKey } from './helpers';

export async function searchRegionsCities(
  httpApi: IHttpApi,
  parameters: ISearchRegionsCitiesRequest,
  subdomain?: string,
) {
  const { response } = await fetchSearchRegionsCities<ISearchRegionsCitiesResponse200, ISearchRegionsCitiesResponse400>(
    {
      httpApi,
      parameters,
      config: {
        subdomain: subdomain || 'www',
      },
    },
  );

  if (isResponseContainsKey<ISearchRegionsCitiesResponseError, ISearchRegionsCitiesResponse>(response, 'errors')) {
    throw response;
  }

  return response;
}
